/**
 * @generated SignedSource<<c4f2f7bc65bb53fceddc6dde5c465543>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPublicProfileInfo_viewer$data = {
  readonly publicProfile: {
    readonly bio: string | null;
    readonly discordLink: string | null;
    readonly displayName: string | null;
    readonly facebookLink: string | null;
    readonly instagramLink: string | null;
    readonly twitterLink: string | null;
    readonly userId: string | null;
    readonly username: string | null;
    readonly walletAddress: {
      readonly address: string | null;
      readonly ensDomain: string | null;
    } | null;
    readonly webLink: string | null;
    readonly wikipediaLink: string | null;
  } | null;
  readonly " $fragmentType": "NftPublicProfileInfo_viewer";
};
export type NftPublicProfileInfo_viewer$key = {
  readonly " $data"?: NftPublicProfileInfo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPublicProfileInfo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "username"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPublicProfileInfo_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "username",
          "variableName": "username"
        }
      ],
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bio",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "discordLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instagramLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "facebookLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wikipediaLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "twitterLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "walletAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ensDomain",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "05e00813a88883e15d514a8354e494f6";

export default node;
